import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Plus } from 'lucide-react';
import { PLATFORM_SUGGESTIONS } from './skillsUtils';

/**
 * Seletor de plataformas compatíveis (Veo Flow, Midjourney, ...): pills de
 * sugestão que ligam/desligam + input para adicionar uma nova. Usado no
 * cadastro de skill do sistema (admin) e de Minhas Skills.
 * value: string[]; onChange(next: string[]).
 */
const PlatformPicker = ({ value = [], onChange }) => {
  const { t } = useTranslation();
  const [custom, setCustom] = useState('');

  const toggle = (p) => {
    onChange(value.includes(p) ? value.filter((v) => v !== p) : [...value, p]);
  };

  const addCustom = () => {
    const v = custom.trim();
    if (!v) return;
    if (!value.some((x) => x.toLowerCase() === v.toLowerCase())) {
      onChange([...value, v]);
    }
    setCustom('');
  };

  // Sugestões + plataformas já selecionadas fora da lista padrão
  const options = [...PLATFORM_SUGGESTIONS];
  for (const v of value) {
    if (!options.some((o) => o.toLowerCase() === v.toLowerCase())) options.push(v);
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        {options.map((p) => {
          const active = value.includes(p);
          return (
            <button
              key={p}
              type="button"
              onClick={() => toggle(p)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '4px',
                padding: '4px 11px', borderRadius: '9999px', fontSize: '11.5px',
                fontWeight: active ? 600 : 400, fontFamily: 'var(--dp-font)',
                cursor: 'pointer', transition: 'all 0.2s ease', lineHeight: 1.4,
                border: active ? '1px solid rgba(13, 174, 255, 0.4)' : '1px solid var(--dp-border-subtle)',
                background: active ? 'rgba(13, 174, 255, 0.1)' : 'transparent',
                color: active ? 'var(--dp-blue-500)' : 'var(--dp-text-tertiary)',
              }}
            >
              {p}
              {active && <X size={10} />}
            </button>
          );
        })}
      </div>
      <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
        <input
          type="text"
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); addCustom(); }
          }}
          placeholder={t('skills.admin.plataformas_placeholder')}
          style={{
            flex: 1, padding: '8px 12px',
            background: 'var(--dp-bg-input, #252525)', border: '1px solid var(--dp-border-subtle)',
            borderRadius: '8px', color: 'var(--dp-text-primary)',
            fontFamily: 'var(--dp-font)', fontSize: '12px', outline: 'none',
            boxSizing: 'border-box',
          }}
        />
        <button
          type="button"
          onClick={addCustom}
          style={{
            padding: '0 12px', borderRadius: '8px',
            border: '1px solid var(--dp-border-medium)', background: 'var(--dp-bg-elevated)',
            color: 'var(--dp-text-primary)', cursor: 'pointer', flexShrink: 0,
          }}
        >
          <Plus size={13} />
        </button>
      </div>
    </div>
  );
};

export default PlatformPicker;
